@if (requiresPrescriptionIdentifiers()) {
  <div class="row mb-3">
    <div class="col-md-6">
      <label class="form-label fw-bold">
        {{ translations2.prescription_id }}
      </label>

      <input
        type="text"
        class="form-control"
        [(ngModel)]="formdata.prescriptionId"
      />
    </div>
  </div>
}

@if (requiresPinCode()) {
  <div class="row mb-3">
    <div class="col-md-6">
      <label class="form-label fw-bold">
        {{ translations2.pin_code }}
      </label>

      <input
        type="text"
        class="form-control"
        [(ngModel)]="formdata.dispensationPINCode"
      />
    </div>
  </div>
}

@if (requiresPrescriptionIdentifiers()) {
  <button
    type="button"
    class="btn btn-primary mb-3"
    (click)="retrieve()"
  >
    {{ translations2.retrieve }}
  </button>
}

@if (loading) {
  <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
    <p-progress-spinner ariaLabel="loading" />
  </div>
} @else {
  @if (!requiresPrescriptionIdentifiers() || list.length > 0 || errorMessage) {
    <h5 class="mb-3">
      {{translations.ep_list}}
    </h5>
  }

  @if (errorMessage) {
    <div class="alert alert-danger">
      {{ errorMessage }}
    </div>
  }

  @if (list.length > 0) {
    @for (item of list; track $index) {
      <div class="p-3 mb-2 bg-light border rounded">
        <div class="row">
          <div class="col-md-10">
            <div class="mb-2">
              <strong>Date:</strong>
              {{ getCreationDate(item) | date: 'dd-MM-yyyy' }}
            </div>

            <div class="mb-2">
              <strong>Description:</strong>
              {{ getDescription(item) }}
            </div>

            <div class="mb-2">
              <strong>Active substance:</strong>
              {{ getActiveSubstance(item) }}
            </div>

            <div class="mb-2">
              <strong>Author:</strong>
              {{ getAuthor(item) }}
            </div>

            <div class="mb-2">
              <strong>Dose form:</strong>
              {{ item.doseFormText }}
            </div>

            <div class="mb-2">
              <strong>ATC Code:</strong>
              {{ item.atcCode }}
            </div>

            <div class="mb-2">
              <strong>Substitution:</strong>
              {{ item.substitution }}
            </div>
          </div>

          <div class="col-md-2 d-flex flex-column gap-2">
            @if (canRetrieve(item)) {
              <button
                type="button"
                class="btn btn-info"
                (click)="printPdf(item)"
              >
                {{ translations2.print }}
              </button>

              <button
                type="button"
                class="btn btn-primary"
                (click)="displayCda(item)"
              >
                {{ translations2.dispense }}
              </button>
            }
          </div>
        </div>
      </div>
    }
  } @else if (!errorMessage && !requiresPrescriptionIdentifiers()) {
    <div class="alert alert-info">
      {{ translations2.prescription_error }}
    </div>
  }

  <div #reportsSection></div>

  @if (documentLoading) {
    <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
      <p-progress-spinner ariaLabel="loading" />
    </div>
  }

  @if (pdfUrl) {
    <embed
      [src]="pdfUrl"
      type="application/pdf"
      width="100%"
      height="1050px"
    />
  }

  @if (htmlUrl) {
    <iframe
      [src]="htmlUrl"
      width="100%"
      height="1050px"
    ></iframe>
  }

  @if (showDispensationForm) {
    <div class="mt-4 p-3 bg-light border rounded">
      <h5 class="mb-3">{{ translations.dispensation_form }}</h5>

      <div class="d-flex flex-column gap-3">

        <ncp-dropdown
          [(options)]="productDropdownOptions"
          [(selectedItem)]="productSelectedItem"
          (selectedItemChange)="onProductSelected($event)"
        />

        <h5>{{translations.description}}</h5>

        <div>
          <label for="dispensationAtcCode" class="form-label">
            {{translations.atc_code}}
          </label>

          <div
            id="dispensationAtcCode"
            class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0 mb10px"
          >
            @if (dispensationForm.atcCode || dispensationForm.atcDescription) {
              <div class="row">
                <div class="col-md-3 text-uppercase">
                  {{ dispensationForm.atcCode }}
                </div>

                <div class="col-md-9 text-uppercase">
                  {{ dispensationForm.atcDescription }}
                </div>
              </div>
            } @else {
              -
            }
          </div>
        </div>

        <div class="d-flex flex-row gap-2 me-4 mb10px">
          <div class="col-6">
            <label for="dispensationStrength" class="form-label">
              {{translations.strength}}
            </label>

            <div
              id="dispensationStrength"
              class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0"
            >
              @if (dispensationForm.strength) {
                <div class="row">
                  <div class="col-12 text-uppercase">
                    {{ dispensationForm.strength }}
                  </div>
                </div>
              } @else {
                -
              }
            </div>
          </div>
        </div>

        <h5>{{translations.packaging}}</h5>

        <div class="d-flex flex-row gap-2">
          <div class="col-9">
            <ncp-dropdown
              [(options)]="packageDropdownOptions"
              [(selectedItem)]="packageSelectedItem"
              (selectedItemChange)="onPackageSelected($event)"
              (click)="punitfetchAll()"
            />
          </div>

          <div class="col-3 pe-2">
            <ncp-input
              [(options)]="numPackagesInputOptions"
            />
          </div>
        </div>

        <h5>{{translations.dosage}}</h5>

        <div class="d-flex flex-row gap-2 me-4">
          <div class="col-3">
            <ncp-input
              [(options)]="quantityInputOptions"
            />
          </div>

          <div class="col-3">
            <ncp-dropdown
              [(options)]="quantityUnitDropdownOptions"
              [(selectedItem)]="quantityUnitSelectedItem"
              (selectedItemChange)="onQuantityUnitSelected($event)"
              (click)="unitsPerIntakeFetchAll()"
            />
          </div>

          <div class="col-3">
            <div class="d-inline-flex flex-nowrap w-100">
              <label
                [for]="frequencyInputOptions().id"
                class="form-label col-form-label me-2 align-self-end pb-3"
              >
                {{translations.every}}
              </label>

              <ncp-input
                class="flex-grow-1"
                [(options)]="frequencyInputOptions"
              />
            </div>
          </div>

          <div class="col-3">
            <ncp-dropdown
              [(options)]="frequencyUnitDropdownOptions"
              [(selectedItem)]="frequencyUnitSelectedItem"
              (selectedItemChange)="onFrequencyUnitSelected($event)"
              (click)="funitfetchAll()"
            />
          </div>
        </div>

        <div class="d-flex flex-row gap-2 me-4">
          <div class="col-3">
            <ncp-input
              [(options)]="durationInputOptions"
            />
          </div>

          <div class="col-3">
            <ncp-dropdown
              [(options)]="durationUnitDropdownOptions"
              [(selectedItem)]="durationUnitSelectedItem"
              (selectedItemChange)="onDurationUnitSelected($event)"
              (click)="dunitfetchAll()"
            />
          </div>

        </div>

        <div class="d-flex flex-row gap-2 me-4">
          <div class="col-6">
            <ncp-dropdown
              [(options)]="pharmacyDropdownOptions"
              [(selectedItem)]="pharmacySelectedItem"
              (selectedItemChange)="onPharmacySelected($event)"
            />
          </div>
        </div>

        <div class="d-flex flex-row gap-2 me-4">
          <div class="col-6">
            <label class="form-label" style="margin-right: 10px">
              {{translations.substitution}}
            </label>

            <ncp-radios
              [(options)]="substitutionRadiosOptions"
            />
          </div>
        </div>

        <div>
          <button
            type="button"
            class="btn btn-primary"
            (click)="dispense()"
            [disabled]="dispenseIsRunning"
          >
            {{translations.dispense}}
          </button>

          @if (dispenseIsRunning) {
            <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
              <p-progress-spinner ariaLabel="loading" />
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (dispensationResults) {
    <div
      class="alert mt-3"
      [class.alert-success]="dispensationIsSuccess"
      [class.alert-danger]="!dispensationIsSuccess"
    >
      {{ dispensationResults }}
    </div>
  }
}
